import { keepPreviousData } from '@tanstack/query-core'
import { PricingPlanResponse } from 'src/queries/organizations/pricingPlans/pricingPlans.types'
import { pricingPlansQueryKeys } from 'src/queries/queries.constants'
import {
  CustomQueryOptions,
  RequestConfig,
  useExtendQuery,
} from 'src/queries/queries.utils'

export function useQueryPricingPlans(
  organizationId?: string,
  options?: CustomQueryOptions<PricingPlanResponse>,
) {
  return useExtendQuery({
    queryKey: pricingPlansQueryKeys.all(),
    queryUrl: () => `/saas/${organizationId}/plans`,
    ...options,
    enabled: !!organizationId && options?.enabled,
  })
}

export function useQueryPricingPlansLookup(
  bin: string,
  options?: CustomQueryOptions<PricingPlanResponse>,
) {
  return useExtendQuery({
    queryKey: pricingPlansQueryKeys.lookup(bin),
    queryUrl: () => `/saas/plans/lookup?bin=${bin}`,
    requestConfig: RequestConfig.Unauthed,
    // Keep the previous lookup result mounted while a new BIN lookup is in flight.
    placeholderData: keepPreviousData,
    retry: false,
    ...options,
    enabled: !!bin && (options?.enabled ?? true),
  })
}
